import React from "react";
import { Utensils, Leaf, Coffee, Footprints, MapPin } from "lucide-react";

const GROUPS = [
  { key: "restaurants", label: "Local restaurants", icon: Utensils },
  { key: "wellness", label: "Wellness shops & spas", icon: Leaf },
  { key: "kava_bars", label: "Kava & tea bars", icon: Coffee },
  { key: "activities", label: "Things to do here", icon: Footprints },
];

function PickGroup({ group, items }) {
  if (!items || items.length === 0) return null;
  const Icon = group.icon;
  return (
    <div data-testid={`local-picks-${group.key}`}>
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-[#C8A96E] mb-2"><Icon size={12} /> {group.label}</div>
      <ul className="space-y-1.5">
        {items.map((p) => (
          <li key={p.name} className="flex items-start justify-between gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2">
            <div className="min-w-0">
              <div className="text-sm text-white leading-tight">{p.name}</div>
              {p.note && <div className="text-[11px] text-[#A89C98] leading-snug mt-0.5">{p.note}</div>}
            </div>
            <a href={p.maps_url} target="_blank" rel="noopener noreferrer" data-testid="local-pick-maps-link" className="shrink-0 inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-[#C8A96E] hover:text-white transition-colors mt-0.5">
              <MapPin size={11} /> Map
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function LocalPicks({ picks, cityDisplay }) {
  if (!picks || GROUPS.every((g) => !(picks[g.key] || []).length)) return null;
  return (
    <div className="mt-6 border-t border-[#C8A96E]/25 pt-5" data-testid="wellness-local-picks">
      <h3 className="text-xs uppercase tracking-[0.28em] text-[#C8A96E]">Local picks in {cityDisplay}</h3>
      <p className="text-[11px] text-[#A89C98] mt-1 mb-3">{picks.source || "Curated for wellness travelers"} · tap Map to open in Google Maps.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {GROUPS.map((g) => <PickGroup key={g.key} group={g} items={picks[g.key]} />)}
      </div>
    </div>
  );
}
